import { adminClient } from './api-client';
import type { KeycloakSession } from './users';

/** Keycloak event representation */
export interface KeycloakEvent {
  time: number;
  type: string;
  realmId: string;
  clientId: string;
  userId: string;
  ipAddress: string;
  details?: Record<string, string>;
}

/** Keycloak admin event representation */
export interface KeycloakAdminEvent {
  time: number;
  realmId: string;
  operationType: string;
  resourceType: string;
  resourcePath: string;
  authDetails: {
    realmId: string;
    clientId: string;
    userId: string;
    ipAddress: string;
  };
}

/** Default max results for event queries */
const DEFAULT_EVENT_MAX = 50;

/** Build a query string from optional filter parameters */
function buildQuery(filters: Record<string, string | number | undefined>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined) params.set(key, String(value));
  }
  if (!params.has('max')) params.set('max', String(DEFAULT_EVENT_MAX));
  return params.toString();
}

/** Fetch active sessions across the realm */
export function fetchActiveSessions(token: string): Promise<KeycloakSession[]> {
  return adminClient(token).get('/sessions/count');
}

/** Fetch login events with optional filters */
export function fetchLoginEvents(
  token: string,
  filters?: { type?: string; dateFrom?: string; dateTo?: string; max?: number },
): Promise<KeycloakEvent[]> {
  return adminClient(token).get(`/events?${buildQuery(filters ?? {})}`);
}

/** Fetch admin events with optional filters */
export function fetchAdminEvents(
  token: string,
  filters?: { operationType?: string; dateFrom?: string; dateTo?: string; max?: number },
): Promise<KeycloakAdminEvent[]> {
  return adminClient(token).get(`/admin-events?${buildQuery(filters ?? {})}`);
}
